import { combineReducers } from 'redux';
import abnormalities from '../../modules/abnormalities/duck';
import abnormalityAnalysis from '../../modules/recoveryActions/analysisDuck';
import dashboard from '../../modules/dashboard/duck';
import manifests from '../../modules/manifests/duck';
import manifestOrderGroups from '../../modules/reports/rfu/duck';
import recoveryActions from '../../modules/recoveryActions/recoveryActionsDuck';
import runs from '../../modules/runs/duck';

export default combineReducers({
    abnormalities,
    abnormalityAnalysis,
    dashboard,
    manifests,
    recoveryActions,
    manifestOrderGroups,
    runs,
});
